module.exports = __webpack_public_path__ + "static/media/plane_45.b0dfbba8.svg";